"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumValidator = void 0;
const ramda_1 = require("ramda");
const validator_1 = require("./validator");
const utils_1 = require("./utils");
class EnumValidator extends validator_1.CommonValidator {
    merge(props) {
        return new EnumValidator({ ...this.props, ...props });
    }
    values(values) {
        return this.merge({ values });
    }
    validateValue = async ({ rootCtx, ctx, options }) => {
        return (0, validator_1.runValidators)({
            rootCtx,
            ctx,
            options,
            validators: [this.validateEnum]
        });
    };
    validateEnum = async ({ rootCtx, ctx, next }) => {
        const values = await (0, utils_1.evaluateValue)(rootCtx, ctx, this.props.values);
        if (values === undefined ||
            values.some(value => (0, ramda_1.equals)(value, ctx.value))) {
            return next();
        }
        ctx.addError({ enum: values });
    };
    isEmptyValue(value) {
        return value === undefined || value === null || value === "";
    }
}
exports.EnumValidator = EnumValidator;
